import { render, staticRenderFns } from "./userLevelList.vue?vue&type=template&id=6f5ffcd7&scoped=true&"
import script from "./userLevelList.vue?vue&type=script&lang=js&"
export * from "./userLevelList.vue?vue&type=script&lang=js&"
import style0 from "./userLevelList.vue?vue&type=style&index=0&id=6f5ffcd7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5ffcd7",
  null
  
)

export default component.exports